import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/AuthStyles.css';
import { login } from '../services/auth';
const Login = () => {
    const navigate = useNavigate();
    const [formData, setFormData] = useState({
        email: '',
        password: '',
    });
    const [errors, setErrors] = useState({});
    const [isLoading, setIsLoading] = useState(false);

    const validateForm = () => {
        const newErrors = {};
        
        if (!formData.email) {
        newErrors.email = 'Email is required';
        } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
        newErrors.email = 'Please enter a valid email address';
        }
        
        if (!formData.password) {
        newErrors.password = 'Password is required';
        } else if (formData.password.length < 8) {
        newErrors.password = 'Password must be at least 8 characters';
        }
        
        setErrors(newErrors);
        return Object.keys(newErrors).length === 0;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
            setFormData(prev => ({
            ...prev,
            [name]: value
        }));
        // Clear error when user starts typing
        if (errors[name]) {
            setErrors(prev => ({
                ...prev,
                [name]: ''
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!validateForm()) return;
        setIsLoading(true);
        try {
            const isLogged = await login(formData);
            if (isLogged) navigate('/dashboard');
        } catch (error) {
            setErrors({
                submit: error.message || 'Invalid email or password'
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="auth-container">
            <div className="auth-card">
                <div className="auth-header">
                    <h1>Sign in</h1>
                    {/* <p>to continue to your account</p> */}
                    {errors.submit && <div className="error-text">{errors.submit}</div>}
                </div>
                
                <form onSubmit={handleSubmit}>
                    <div className="form-group">
                        <input
                            type="email"
                            name="email"
                            className="form-control"
                            placeholder=" "
                            value={formData.email}
                            onChange={handleChange}
                        />
                        <label className="form-label">Email</label>
                        {errors.email && <div className="error-text">{errors.email}</div>}
                    </div>
                    
                    <div className="form-group">
                        <input
                            type="password"
                            name="password"
                            className="form-control"
                            placeholder=" "
                            value={formData.password}
                            onChange={handleChange}
                        />
                        <label className="form-label">Password</label>
                        {errors.password && <div className="error-text">{errors.password}</div>}
                    </div>
                    <button 
                        type="submit" 
                        className="auth-button"
                        disabled={isLoading}
                    >
                        {isLoading ? 'Signing in...' : 'Sign in'}
                    </button>
                </form>
                
                <div className="auth-links">
                    {/* <a href="/forgot-password" className="auth-link">Forgot password?</a> */}
                    <a href="/register" className="auth-link">Create account</a>
                </div>
            </div>
        </div>
    );
};

export default Login;